module.exports = __webpack_public_path__ + "5ba951c11e1c94c06f6336cbdcc82c8b.svg";